import React, { useState } from "react";
import logo from "../assets/primary_bg_removed.png";

const Layout = ({children, onUpdateClick  }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const styles = {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "-0.015em",
    color: "#4C4D5E",
  };

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    const offset = 100;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
    
    // Close mobile menu after clicking a link
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen w-full my-0">
      {/* Navigation Header */}
      <nav
        className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
        style={{
          backgroundColor: "#FAF9FF",
        }}
      >
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src={logo}
              alt="Zeta Logo"
              style={{
                width: "160px",
                height: "auto",
                top: "10px",
                left: "57px",
                gap: "5.9px",
                opacity: "0px",
                backgroundColor: "#FAF9FF",
              }}
            />
          </div>

          {/* Desktop Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#about" onClick={(e) => scrollToSection(e, 'about')} style={styles}>
              About
            </a>
            <a href="#faqs" onClick={(e) => scrollToSection(e, 'faqs')} style={styles}>
              FAQs
            </a>
            <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')} style={styles}>
              Contact
            </a>
            <button
              className="text-white px-5 py-1.5 rounded-md font-medium"
              style={{
                fontFamily: "Inter",
                backgroundColor: "#0C60F2",
                fontSize: "13px",
                fontWeight: 600,
                lineHeight: "20px",
                letterSpacing: "-0.015em",
                color: "#FFFFFF",
              }}
              onClick={onUpdateClick}
            >
              Sign Up for Updates
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button 
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <span className="sr-only">Open menu</span>
              {/* Menu icon */}
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMobileMenuOpen ? (
                  // X icon when menu is open
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  // Hamburger icon when menu is closed
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg z-50">
            <div className="px-4 py-3 space-y-4">
              <a
                href="#about"
                onClick={(e) => scrollToSection(e, 'about')}
                className="block py-2 text-base hover:text-blue-600"
                style={styles}
              >
                About
              </a>
              <a
                href="#faqs"
                onClick={(e) => scrollToSection(e, 'faqs')}
                className="block py-2 text-base hover:text-blue-600"
                style={styles}
              >
                FAQs
              </a>
              <a
                href="#contact"
                onClick={(e) => scrollToSection(e, 'contact')}
                className="block py-2 text-base hover:text-blue-600"
                style={styles}
              >
                Contact
              </a>
              <button
                className="w-full text-white px-5 py-1.5 rounded-md font-medium"
                style={{
                  fontFamily: "Inter",
                  backgroundColor: "#0C60F2",
                  fontSize: "13px",
                  fontWeight: 600,
                  lineHeight: "20px",
                  letterSpacing: "-0.015em",
                  color: "#FFFFFF",
                }}
                onClick={onUpdateClick}
              >
                Sign Up for Updates
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Main Content */}
      <main className="flex-1">{children}</main>
    </div>
  );
};

export default Layout;





// import React from "react";
// import logo from "../assets/Primary.jpg";

// const Layout = ({ children }) => {
//   const styles = {
//     fontFamily: "Inter",
//     fontSize: "14px",
//     fontWeight: 600,
//     lineHeight: "24px",
//     letterSpacing: "-0.015em",
//     color: "#4C4D5E",
//   };

//     const scrollToSection = (e, sectionId) => {
//       e.preventDefault();
//       const element = document.getElementById(sectionId);
//       const offset = 100; // Adjust this value based on your header height
//       const elementPosition = element.getBoundingClientRect().top;
//       const offsetPosition = elementPosition + window.scrollY - offset;
    
//       window.scrollTo({
//         top: offsetPosition,
//         behavior: "smooth"
//       });
//     };
  

//   return (
//     <div className="min-h-screen w-full my-0">
//       {/* Navigation Header */}
//       <nav
//         className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
//         style={{
//           backgroundColor: "#FAF9FF",
//         }}
//       >
//         <div className="flex justify-between items-center">
//           {/* Logo */}
//           <div className="flex items-center">
//             <img
//               src={logo}
//               alt="Zeta Logo"
//               style={{
//                 width: "160px",
//                 height: "auto",
//                 top: "10px",
//                 left: "57px",
//                 gap: "5.9px",
//                 opacity: "0px",
//                 backgroundColor: "#FAF9FF",
//               }}
//             />
//           </div>

//           {/* Navigation Links */}
//           <div className="hidden md:flex items-center space-x-8">
//             <a href="#about" onClick={(e) => scrollToSection(e, 'about')}  style={styles}>
//               About
//             </a>
//             <a href="#faqs" onClick={(e) => scrollToSection(e, 'faqs')} style={styles}>
//               FAQs
//             </a>
//             <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')} style={styles}>
//               Contact
//             </a>
//             <button
//               className=" text-white px-5 py-1.5 rounded-md font-medium"
//               style={{
//                 fontFamily: "Inter",
//                 backgroundColor: "#0C60F2",
//                 fontSize: "13px",
//                 fontWeight: 600,
//                 lineHeight: "20px",
//                 letterSpacing: "-0.015em",
//                 color: "#FFFFFF",
//               }}
//             >
//               Sign Up for Updates
//             </button>
//           </div>

//           {/* Mobile menu button */}
//           <div className="md:hidden">
//             <button className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100">
//               <span className="sr-only">Open menu</span>
//               {/* Menu icon */}
//               <svg
//                 className="h-6 w-6"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M4 6h16M4 12h16M4 18h16"
//                 />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </nav>

//       {/* Main Content */}
//       <main className="flex-1">{children}</main>
//     </div>
//   );
// };

// export default Layout;